import React from 'react';
import { Route, Routes } from 'react-router-dom';

import HeaderSecondary from '@components/HeaderSecondary';

import CorporateHealthQuoteBuyNewPage from './CorporateHealthQuoteBuyNewPage';
import CorporateHealthQuoteBuyReviewPage from './CorporateHealthQuoteBuyReviewPage';
import CorporateHealthQuoteBuyEditPage from './CorporateHealthQuoteBuyEditPage';
import CorporateHealthQuoteBuyLockPage from './CorporateHealthQuoteBuyLockPage';
import CorporateHealthQuoteBuyPayByCashPage from './CorporateHealthQuoteBuyPayByCashPage';

const CorporateHealthQuoteBuyRoute = () => {
  return (
    <>
      <HeaderSecondary />
      <Routes>
        <Route index element={<CorporateHealthQuoteBuyNewPage />} />
        <Route path="/:orderNumber/review" element={<CorporateHealthQuoteBuyReviewPage />} />
        <Route path="/:orderNumber/edit" element={<CorporateHealthQuoteBuyEditPage />} />
        <Route path="/:orderNumber/lock" element={<CorporateHealthQuoteBuyLockPage />} />
        <Route path="/:orderNumber/pay-by-cash" element={<CorporateHealthQuoteBuyPayByCashPage />} />
      </Routes>
    </>
  );
};

export { CorporateHealthQuoteBuyRoute };
